import React, { Fragment } from 'react';
import personalaccess from '../../../../../images/caraccessByWard.png';
import personalaccess2 from '../../../../../images/caraccessByWard2.png';
import '../../driverFaq.css';

const PersonalVehicleAccess = () => (
  <Fragment>
    <p>
      There are driving entrances to the garage on George St and York St.
    </p>
    <br />
    <div style={{ textAlign: 'center', width: '100%' }}>
      <img src={personalaccess} />
    </div>
    <br />
    <p>
      Enter the parking lot on George St. and tap the reserved parking card
      at the entrance gate to open it. Once the gate opens, pull through
      and keep to the left to go up the ramp. Follow the Autzu signage to
      P4.
    </p>
    <br />
    <div style={{ textAlign: 'center', width: '100%' }}>
      <img src={personalaccess2} />
    </div>{' '}
    <br />
    <p>
      Alternatively, enter the parking lot on York St. and tap the reserved
      parking card at the entrance gate to open it. Once the gate opens,
      pull through and keep to the right to go up the ramp. Follow the
      Autzu signage to P4.
    </p>
  </Fragment>
);

export default PersonalVehicleAccess;



// WEBPACK FOOTER //
// ./src/components/Static/DriverFaq/ParkingHub/Metcalfe/PersonalVehicleAccess.js